import script from "./courseGoals.vue?vue&type=script&setup=true&lang=js"
export * from "./courseGoals.vue?vue&type=script&setup=true&lang=js"

import "./courseGoals.vue?vue&type=style&index=0&id=57a3ba3b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a3ba3b"]])

export default __exports__